import { QActionSelect } from '@kw/quokka-ui';
import { dateRange as defaultDateRange } from '../shared/constants';

interface DateRangeSelectProps {
  dateRangeOption?: { label: string; value: number }[];
  selectedDateRange: number;
  custom?: boolean;
  handleDateRangeChange: (event: React.ChangeEvent<{ value: number }>) => void;
}

export const DateRangeSelect = ({ selectedDateRange, custom, handleDateRangeChange, dateRangeOption }: DateRangeSelectProps) => {
  const dateRange = dateRangeOption || defaultDateRange;
  return (
    <QActionSelect
      variant="filled"
      closedLabel={custom ? 'Custom' : dateRange.find(range => range.value === selectedDateRange)?.label}
      formControlProps={{
        className: 'mx-1 toggledown-primary',
        style: {
          paddingTop: '0px',
          paddingRight: '0px',
        },
        sx: {
          width: '130px',
          '& .MuiFilledInput-root': {
            backgroundColor: 'white',
          },
          '& .MuiSelect-icon': {
            color: 'black',
          },
          '&:hover .MuiFilledInput-root, &:focus-within .MuiFilledInput-root': {
            backgroundColor: 'white',
          },
          '&:hover .MuiSelect-icon, &:focus-within .MuiSelect-icon': {
            color: 'black',
          },
          '& label': {
            color: 'black',
            transform: 'translate(16px, 6px) scale(1)',
          },
          '&:hover label, &:focus-within label': {
            color: 'black',
          },
        },
      }}
      labelProps={{
        sx: {
          transform: 'translate(16px, 6px) scale(1)',
        },
      }}
      options={[...(custom ? [{ value: 'custom', label: 'Custom' }] : []), ...dateRange]}
      selectProps={{ onChange: handleDateRangeChange }}
    />
  );
};
